<template>
  <div data-testid="accruals-agent-settings" class="accruals-agent-settings">
    <div class="accruals-agent-settings__nav d-flex align-center">
      <base-button
        icon-style
        small
        class="shadow-off accruals-agent-settings__back-btn"
        image="/img/icons/fbc-icons/BackArrow.svg"
        image-alt="Back"
        aria-label="Back to Agent Settings"
        data-testid="accruals-agent-settings__back-btn"
        @click="onBackClick"
      />

      <nav
        class="accruals-agent-settings__breadcrumb d-flex align-center"
        aria-label="Breadcrumb"
        data-testid="accruals-agent-settings__breadcrumb"
      >
        <button
          type="button"
          class="accruals-agent-settings__breadcrumb-link"
          data-testid="accruals-agent-settings__breadcrumb-link"
          @click="onBackClick"
        >
          Back to Agent Settings
        </button>
      </nav>
    </div>

    <h1 data-testid="accruals-agent-settings__title" class="accruals-agent-settings__title">
      Accruals Agent Settings
    </h1>

    <div data-testid="accruals-agent-settings__tabs" class="accruals-agent-settings__tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        :data-testid="`accruals-agent-settings__tab--${tab.key}`"
        type="button"
        class="accruals-agent-settings__tab"
        :class="{ 'accruals-agent-settings__tab--active': activeTab === tab.key }"
        @click="onTabClick(tab.key)"
      >
        {{ tab.label }}
      </button>
    </div>

    <accruals-system-instruction-panel
      v-if="activeTab === 'system-instruction'"
      data-testid="accruals-agent-settings__system-instruction"
    />

    <div
      v-else-if="activeTab === 'vendor-instruction'"
      data-testid="accruals-agent-settings__vendor-placeholder"
      class="accruals-agent-settings__placeholder"
    >
      Vendor-specific instructions will be configured here.
    </div>

    <accruals-data-ingestion-panel
      v-else-if="activeTab === 'data-ingestion'"
      ref="ingestionPanel"
      data-testid="accruals-agent-settings__data-ingestion"
    />

    <accruals-column-mapping-panel
      v-else-if="activeTab === 'column-mapping'"
      :active="activeTab === 'column-mapping'"
      data-testid="accruals-agent-settings__column-mapping"
    />

    <accruals-activity-panel
      v-else-if="activeTab === 'activity'"
      :active="activeTab === 'activity'"
      data-testid="accruals-agent-settings__activity"
    />
  </div>
</template>

<script>
import AccrualsSystemInstructionPanel from './AccrualsSystemInstructionPanel.vue';
import AccrualsDataIngestionPanel from './AccrualsDataIngestionPanel.vue';
import AccrualsColumnMappingPanel from './AccrualsColumnMappingPanel.vue';
import AccrualsActivityPanel from './AccrualsActivityPanel.vue';
import {
  ADMIN_CONSOLE_ROUTES,
  ADMIN_CONSOLE_ACCRUALS_TABS,
  buildAdminConsoleRouteQuery,
} from '@/modules/admin/utils/adminConsoleConstants';

export default {
  name: 'AccrualsAgentSettings',
  components: {
    AccrualsSystemInstructionPanel,
    AccrualsDataIngestionPanel,
    AccrualsColumnMappingPanel,
    AccrualsActivityPanel,
  },
  data() {
    return {
      activeTab: 'system-instruction',
      tabs: ADMIN_CONSOLE_ACCRUALS_TABS,
    };
  },
  methods: {
    onTabClick(key) {
      if (key === this.activeTab) return;
      if (!this.confirmLeaveIngestion()) return;
      this.activeTab = key;
    },
    confirmLeaveIngestion() {
      const panel = this.$refs.ingestionPanel;
      if (this.activeTab !== 'data-ingestion' || !panel || typeof panel.confirmLeave !== 'function') return true;
      return panel.confirmLeave();
    },
    onBackClick() {
      if (!this.confirmLeaveIngestion()) return;
      const query = buildAdminConsoleRouteQuery(this.$route, this.$store.state.client);
      this.$router.push({ path: ADMIN_CONSOLE_ROUTES.AGENT_SETTINGS, query }).catch((err) => {
        if (err?.name === 'NavigationDuplicated') return;
      });
    },
  },
};
</script>

<style lang="scss" scoped src="./AccrualsAgentSettings.scss"></style>
